import { createContext } from 'react'
import type { UploadManager } from './upload-manager.js'

export const UploadContext = createContext<UploadManager | null>(null)
